import React, { useState } from "react";
import { referenceYearOptions } from "../../referenceYear";

interface Props {
  nome: string;
  descrizione: string;
  referenceYear: number;
  setNome: (val: string) => void;
  setDescrizione: (val: string) => void;
  setReferenceYear: (val: number) => void;
  onPrevStep: () => void;
  onSubmit: () => void;
  /** Vero mentre la creazione e' in volo. */
  creating: boolean;
  /** Errore restituito dal server sulla creazione, mostrato qui sotto. */
  errore: string;
}

const Step3ReportDetails: React.FC<Props> = ({
  nome,
  descrizione,
  referenceYear,
  setNome,
  setDescrizione,
  setReferenceYear,
  onPrevStep,
  onSubmit,
  creating,
  errore,
}) => {
  const [error, setError] = useState<string>("");
  /**
   * La conferma sta qui dentro e non in un popup: il wizard e' a sua volta un
   * popup SweetAlert, e una `Swal.fire` annidata lo sostituirebbe.
   */
  const [confermando, setConfermando] = useState(false);

  const regex = /^[a-zA-Z0-9À-ž\s]*$/;
  const years = referenceYearOptions();

  const handleChangeNome = (value: string) => {
    if (regex.test(value)) setNome(value);
    if (error) setError("");
  };

  const handleChangeDescrizione = (value: string) => {
    if (regex.test(value)) setDescrizione(value);
    if (error) setError("");
  };

  const handleCrea = () => {
    if (!nome.trim() || !descrizione.trim()) {
      setError("Compila tutti i campi prima di procedere.");
      return;
    }
    if (!years.includes(referenceYear)) {
      setError(`L'anno di riferimento deve essere ${years.join(" o ")}.`);
      return;
    }
    setError("");
    setConfermando(true);
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col items-start">
        {error && (
          <div className="text-red-600 text-center mb-2">{error}</div>
        )}
        <label className="mb-1 text-sm font-medium w-full">Nome</label>
        <input
          type="text"
          value={nome}
          onChange={(e) => handleChangeNome(e.target.value)}
          placeholder="Inserisci il nome del report"
          className="w-full p-2 border border-divider rounded"
        />
      </div>
      <div className="flex flex-col items-start">
        <label className="mb-1 text-sm font-medium w-full">Descrizione</label>
        <textarea
          value={descrizione}
          onChange={(e) => handleChangeDescrizione(e.target.value)}
          placeholder="Inserisci una breve descrizione"
          className="w-full p-2 border border-divider rounded"
          rows={4}
        />
      </div>
      <div className="flex flex-col items-start">
        <label className="mb-1 text-sm font-medium w-full">Anno di riferimento</label>
        <select
          value={referenceYear}
          onChange={(e) => {
            setReferenceYear(Number(e.target.value));
            if (error) setError("");
          }}
          className="w-full p-2 border border-divider rounded bg-white"
        >
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
        <p className="mt-1 text-xs text-textSecondary text-left">
          Seleziona la colonna dell'anno nelle tabelle dei valori scambiati. Incide solo sul
          driver penetrazione mercati, non sul resto del report.
        </p>
      </div>
      {errore && (
        <div className="border border-red-300 rounded p-3 text-sm text-red-800 text-left">
          {errore}
        </div>
      )}

      {confermando ? (
        <div className="border border-yellow-300 rounded p-3 flex flex-col gap-3">
          <div className="text-sm text-yellow-900 text-left">
            Sei sicuro di voler procedere con la creazione del report?
          </div>
          <div className="flex justify-end gap-2">
            <button
              onClick={() => setConfermando(false)}
              disabled={creating}
              className="px-4 py-2 bg-gray-300 text-gray-800 hover:bg-gray-400 rounded disabled:opacity-50 disabled:cursor-not-allowed"
            >
              No
            </button>
            <button
              onClick={onSubmit}
              disabled={creating}
              className="px-4 py-2 bg-textPrimary text-white hover:bg-textSecondary rounded disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {creating ? "Creazione…" : "Sì, crea il report"}
            </button>
          </div>
        </div>
      ) : (
        <div className="flex justify-between mt-4">
          <button
            onClick={onPrevStep}
            className="px-4 py-2 bg-buttonPrimaryBg text-buttonPrimaryText hover:bg-buttonPrimaryHover rounded"
          >
            Indietro
          </button>
          <button
            onClick={handleCrea}
            className="px-4 py-2 bg-textPrimary text-white hover:bg-textSecondary rounded"
          >
            Crea
          </button>
        </div>
      )}
    </div>
  );
};

export default Step3ReportDetails;
